import { render, staticRenderFns } from "./MoreMenuItemSeparator.vue?vue&type=template&id=639ac081&scoped=true&"
import script from "./MoreMenuItemSeparator.vue?vue&type=script&lang=ts&"
export * from "./MoreMenuItemSeparator.vue?vue&type=script&lang=ts&"
import style0 from "./MoreMenuItemSeparator.vue?vue&type=style&index=0&id=639ac081&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639ac081",
  null
  
)

export default component.exports